import type { WarehouseType } from "@/graphql/codegen/graphql"

export enum WarehouseStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

export interface WarehouseFilterFormValues {
  isActive: WarehouseStatus | WarehouseStatus[] | undefined | boolean
  types: WarehouseType[] | null
  companyIds: string[] | null
}

export interface WarehouseFormPayload {
  externalSystemId: string
  type: WarehouseType
  receivingHoursFrom: string | null
  receivingHoursTo: string | null
  shippingHoursFrom: string | null
  shippingHoursTo: string | null
  specialInstructions: string | null
  monthlyAccrualFee: number | null
  inboundFee: number | null
  outboundFee: number | null
  miscellaneousFees: {
    type: string
    amount: number
  }[]
}
